/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Platform_Preview_TitleInputs */

const en_platform_preview_title = /** @type {(inputs: Platform_Preview_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A day that fills itself`)
};

const pl_platform_preview_title = /** @type {(inputs: Platform_Preview_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dzień, który układa się sam`)
};

/**
* | output |
* | --- |
* | "A day that fills itself" |
*
* @param {Platform_Preview_TitleInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const platform_preview_title = /** @type {((inputs?: Platform_Preview_TitleInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Platform_Preview_TitleInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_platform_preview_title(inputs)
	return en_platform_preview_title(inputs)
});